import { render } from "./HowToWashView.vue?vue&type=template&id=43711471&scoped=true"
import script from "./HowToWashView.vue?vue&type=script&lang=js"
export * from "./HowToWashView.vue?vue&type=script&lang=js"

import "./HowToWashView.vue?vue&type=style&index=0&id=43711471&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43711471"]])

export default __exports__